import * as React from 'react';
import {useEffect, useState} from "react";
import { fetchMenuByUrl } from "../loaders.ts";
import type { MenuData } from "../rest.interface";
import Footer from "./footer.tsx";

interface Props {}

function FooterLoader({...otherProps}: Props) {

	const [menu, setMenu] = useState<MenuData>(null);
	const [menuSocial, setMenuSocial] = useState<MenuData>(null);
	const [menuEmail, setMenuEmail] = useState<MenuData>(null);
	const [menuPhone, setMenuPhone] = useState<MenuData>(null);

	useEffect(() => {
		fetchMenuByUrl('footer').then((data) => {
			setMenu(data);
		});

		fetchMenuByUrl('footer-social').then((data) => {
			setMenuSocial(data);
		});

		fetchMenuByUrl('footer-email').then((data) => {
			setMenuEmail(data);
		});

		fetchMenuByUrl('footer-phone').then((data) => {
			setMenuPhone(data);
		});
	}, []);

	return (<>
		<Footer
			menu={menu}
			menuSocial={menuSocial}
			menuEmail={menuEmail}
			menuPhone={menuPhone}
			pathname={window.location.pathname}
			{...otherProps}
		/>
	</>);
}

export default FooterLoader;
